export default {
  pageTitle: 'Layanan Perbaikan Piping',
  metaDescription: 'TEF menyediakan layanan perbaikan dan pemeliharaan piping untuk memulihkan integritas sistem dan mencegah downtime pada piping proses yang kritis.',
  sidebar: {
    heading: 'Daftar Pemeliharaan dan Rekondisi',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Piping',
  heading: 'Layanan Fabrikasi dan Pengelasan Piping yang Menyeluruh',
  paragraph1: 'Kami berspesialisasi dalam fabrikasi, pengelasan, dan instalasi sistem piping yang disesuaikan dengan kebutuhan spesifik Anda. Layanan kami menawarkan fleksibilitas, dengan fabrikasi yang dapat dilakukan di workshop kami maupun langsung di lokasi proyek Anda, tergantung kebutuhan pekerjaan.',
  paragraph2: 'Mulai dari pengelasan presisi hingga instalasi yang mulus, tim berpengalaman kami memastikan standar kualitas tertinggi di setiap tahapan proses. Dengan menawarkan layanan on-site, kami meminimalkan downtime dan meningkatkan efisiensi, memberikan solusi andal yang terintegrasi dengan lancar ke dalam operasional Anda.',
  steps: {
    step1: 'Pengelasan di Workshop',
    step2: 'Instalasi Piping',
    step3: 'Instalasi Support',
    step4: 'Instalasi Piping',
    step5: 'Instalasi Support',
    step6: 'Instalasi Support',
    step7: 'Instalasi Support',
  },
};
